import { render, staticRenderFns } from "./teamtMoreRewardRecord.vue?vue&type=template&id=2727ecc0&"
import script from "./teamtMoreRewardRecord.vue?vue&type=script&lang=js&"
export * from "./teamtMoreRewardRecord.vue?vue&type=script&lang=js&"
import style0 from "./teamtMoreRewardRecord.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports